
define('text!analytics-popover/analytics-popover.html',[],function () { return '<div class="popover-template">\n\t<div id="analytics-popover-content">\n\t\t<div>{{\'welcome.analyticsPopover.setSaleMessage\' | i18n}}</div>\n\t\t<b>{{\'welcome.analyticsPopover.startInsights\' | i18n}}</b>\n\t\t<div class="footer" />\n\t</div>\n</div>\n';});

